/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener( 'DOMContentLoaded', function() {
    
    const block_containers = document.querySelectorAll( '.wp-block-hemis-blocks-materiautheque' );

    for ( let i = 0; i < block_containers.length; i++ ) {

        // On va chercher les blocs de catégories pour y appliquer les événements de clic
        const categories_container = block_containers[i].querySelectorAll( '.materiautheque-category' );
        for ( let j = 0; j < categories_container.length; j++ ) {
            categories_container[j].addEventListener( 'click', function() {

                categories_container[j].parentElement.classList.add( 'has-selection' );

                // On va chercher le slug en cours
                const current_slug = categories_container[j].dataset.slug;

                // On cache toutes les catégories sans ce slug
                const categories_to_hide = block_containers[i].querySelectorAll( '.materiautheque-category:not([data-slug="' + current_slug + '"])' );
                for ( let k = 0; k < categories_to_hide.length; k++ ) {
                    categories_to_hide[k].classList.remove( 'current' );
                }

                // On affiche la catégorie sélectionnée
                const category_to_show = block_containers[i].querySelector( '.materiautheque-category[data-slug="' + current_slug + '"]' );
                if ( category_to_show ) {
                    category_to_show.classList.add( 'current' );
                }

                // On scroll jusqu'aux galeries de matériaux
                const anchor = block_containers[i].querySelector( '.site-anchor' );
                if ( anchor ) {
                    anchor.scrollIntoView( { behavior: 'smooth' } );
                }

                // On cache toutes les galleries de matériaux sauf celles de la catégorie sélectionnée
                const galleries_container = block_containers[i].querySelectorAll( '.materiautheque-materals-container' );
                for ( let k = 0; k < galleries_container.length; k++ ) {
                    if ( galleries_container[k].classList.contains( 'materals-' + current_slug ) ) {
                        galleries_container[k].classList.add( 'current' );
                    } else {
                        galleries_container[k].classList.remove( 'current' );
                    }
                }

                // On cache toutes les galleries mobile de matériaux sauf celles de la catégorie sélectionnée
                const galleries_mobile_container = block_containers[i].querySelectorAll( '.materiautheque-materals-container-mobile' );
                for ( let k = 0; k < galleries_mobile_container.length; k++ ) {
                    if ( galleries_mobile_container[k].classList.contains( 'materals-' + current_slug ) ) {
                        galleries_mobile_container[k].classList.add( 'current' );
                    } else {
                        galleries_mobile_container[k].classList.remove( 'current' );
                    }
                }
                
            });
        }

        if ( 'undefined' !== typeof lightGallery ) {
            const galleries = block_containers[i].querySelectorAll( '.materiautheque-materal-gallery, .materiautheque-materal-gallery-mobile' );
            for ( let j = 0; j < galleries.length; j++ ) {
                lightGallery( galleries[j], {
                    thumbnail: true,
                    download: false,
                    actualSize: false,
                } );
            }
        }
    }

});